module.exports = function (hub, scene, localstore) {
  require('./auth')(hub, scene, localstore)
  return require('./panes')(hub, scene, localstore)
}
